module.exports = __webpack_public_path__ + "media/images/clients/share-fb1b3ec7267ab86d561a91613a08f905.svg";